import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getPairingStatusAPI } from './api';

export const GET_PAIRING_STATUS = 'getPairingStatus';

export function useGetPairingStatus(user) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery(
    [GET_PAIRING_STATUS, tenantId, user?.email],
    () => getPairingStatusAPI(user),
  );

  return {
    data,
    mobileKeyHash: data?.mobileKey?.mobileKeyHash || null,
    isPairingInitiated: data?.mobileKey?.pairingInitiated,
    isPaired: data?.mobileKey?.paired || false,
    code: data?.mobileKey?.pin || null,
    validNumberOfDays: data?.mobileKey?.validUntil || 0,
    isLoading,
    isFetching,
    isError,
  };
}

